"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const theme_1 = require("@zapier/theme");
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const DrawerTabContext_1 = require("./DrawerTabContext");
const tabIconSize = 20;
const tabItemPadding = theme_1.Spacing.small;
const tabItemSize = tabIconSize + tabItemPadding * 2;
const tabItemMargin = theme_1.Spacing.small;
const getItemColorAndFill = ({ isErrored, isSelected }) => common_utils_1.cond([isSelected, theme_1.Colors.white], [isErrored, theme_1.Colors.red500], theme_1.Colors.batmobile);
const getItemHoverColorAndFill = ({ isErrored, isSelected, }) => common_utils_1.cond([isSelected, theme_1.Colors.white], [isErrored, theme_1.Colors.red700], theme_1.Colors.blackWidow);
const Styles = common_utils_1.labelStyles('DrawerTabs', {
    root: {
        backgroundColor: theme_1.Colors.white,
        borderLeft: `1px solid ${theme_1.Colors.adamantium}`,
    },
    tabItem: ({ isErrored, isSelected }) => ({
        alignItems: 'center',
        backgroundColor: common_utils_1.cond([isSelected, theme_1.Colors.blue500], [isErrored, theme_1.Colors.red100], theme_1.Colors.storm),
        border: `1px solid ${theme_1.Colors.white}`,
        borderRadius: tabItemPadding,
        color: getItemColorAndFill({
            isErrored,
            isSelected,
        }),
        cursor: 'pointer',
        display: 'flex',
        fill: getItemColorAndFill({
            isErrored,
            isSelected,
        }),
        height: tabItemSize,
        justifyContent: 'center',
        padding: tabItemPadding,
        position: 'relative',
        margin: `${theme_1.Spacing.extraSmall}px ${theme_1.Spacing.small}px`,
        width: tabItemSize,
        ':hover': {
            backgroundColor: common_utils_1.cond([isSelected, theme_1.Colors.blue700], [isErrored, theme_1.Colors.red200], theme_1.Colors.adamantium),
            color: getItemHoverColorAndFill({
                isErrored,
                isSelected,
            }),
            fill: getItemHoverColorAndFill({
                isErrored,
                isSelected,
            }),
        },
        ':focus': {
            boxShadow: isSelected
                ? `0px 0px 0px 2px ${theme_1.Colors.blue700}`
                : `0px 0px 0px 2px ${theme_1.Colors.blue500}`,
            outline: 'none',
        },
    }),
    tabItemContainer: {
        display: 'block',
    },
    tabItemCount: {
        fontSize: 10,
        fontWeight: 'bold',
        position: 'absolute',
        right: 2,
        top: 2,
    },
});
const DrawerTabItem = ({ formatTabItemCount, item: { count, icon, id, isErrored, label, onClick }, isSelected, onSelectTab, }) => (common_utils_1.isolateComponent("div", { css: Styles.tabItemContainer },
    common_utils_1.isolateComponent(design_system_1.TooltipWrapper, { content: label, position: "west" }, ({ childProps }) => (common_utils_1.isolateComponent("button", Object.assign({}, design_system_1.kebabCaseAriaAttrs(childProps), { "aria-label": isSelected ? `close the ${label} tab` : `open the ${label} tab`, css: Styles.tabItem({
            isErrored,
            isSelected,
        }), onClick: () => onClick ? onClick() : onSelectTab(isSelected ? undefined : id), title: label }),
        !!count && count > 0 && (common_utils_1.isolateComponent("div", { css: Styles.tabItemCount }, formatTabItemCount ? formatTabItemCount(count) : count)),
        common_utils_1.isolateComponent(design_system_1.Icon, { color: "inherit", name: icon, size: tabIconSize }))))));
const FastDrawerTabItem = react_1.memo(DrawerTabItem);
const DrawerTabs = ({ formatTabItemCount, items = [] }) => {
    const { selectedTabId, onSelectTab } = DrawerTabContext_1.useDrawerTabContext();
    return (common_utils_1.isolateComponent("nav", { css: Styles.root }, items.map(item => (common_utils_1.isolateComponent(FastDrawerTabItem, { formatTabItemCount: formatTabItemCount, isSelected: item.id === selectedTabId, item: item, key: item.id, onSelectTab: onSelectTab })))));
};
DrawerTabs.Width = tabItemSize + tabItemMargin * 2;
DrawerTabs.defaultProps = {
    formatTabItemCount: (count) => Math.min(count, 9),
};
exports.default = DrawerTabs;
